import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "ml-2 title text-h6 font-weight-medium mb-0 pb-0" }
const _hoisted_3 = { class: "ml-2 title text-body1 mt-n2" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}

import { withDefaults, computed, ref, onMounted, nextTick } from 'vue'
import SubscribeStep from './StepTypes/Subscribe.vue'
import TriggerStep from './StepTypes/Trigger.vue'
import GoalStep from './StepTypes/Goal.vue'
import WaitStep from './StepTypes/Wait.vue'
import EmailStep from './StepTypes/Email.vue'
import ConditionStep from './StepTypes/Condition.vue'
import StepType from '@/lib/enums/StepType'
import { DfNode, DfNodeData } from '@/interfaces/drawflow'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'
import { IStep } from '@/interfaces/hoppermation'

interface IProps {
  toggleDetails?: () => void
  step?: IStep
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editor?: any
}


export default /*#__PURE__*/_defineComponent({
  props: {
    toggleDetails: { type: Function, required: false, default: () => ({}) },
    step: { type: null, required: false, default: () => ({} as IStep) },
    editor: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { toggleDetails: () => void, step: IStep, editor: any }


const isDataReady = ref(false)
const uiId = ref('')
const node = ref({} as DfNode)
const stepElement = ref()

const isTriggerStep = computed((): boolean => {
  return props.step.type === StepType.TRIGGER
})

const isGoalStep = computed((): boolean => {
  return props.step.type === StepType.GOAL
})

const isWaitStep = computed((): boolean => {
  return props.step.type === StepType.WAIT
})

const isEmailStep = computed((): boolean => {
  return props.step.type === StepType.EMAIL
})

const isSubscribeStep = computed((): boolean => {
  return props.step.type === StepType.SUBSCRIBE
})

const isConditionStep = computed((): boolean => {
  return props.step.type === StepType.CONDITION
})

onMounted(() => {
  nextTick(() => {
    uiId.value = stepElement.value.parentElement.parentElement.id
    node.value = props.editor.getNodeFromId(uiId.value.slice(5))
    isDataReady.value = true
  })

  bus.$on(EventNames.DF_UPDATE_NODE_DETAILS, (data: { id: string; details: DfNodeData }) => {
    if (data.id === `node-${node.value.id}`) {
      node.value.data = data.details
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "header d-flex align-center",
      ref: (_value, _refs) => {
        _refs['stepElement'] = _value
        stepElement.value = _value
      }
    }, [
      _createElementVNode("img", {
        src: props.step.icon,
        height: "32"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(props.step.title)), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(isDataReady.value ? node.value.data.stepName : ''), 1)
      ])
    ], 512),
    (isDataReady.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(isTriggerStep))
            ? (_openBlock(), _createBlock(TriggerStep, {
                key: 0,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true),
          (_unref(isGoalStep))
            ? (_openBlock(), _createBlock(GoalStep, {
                key: 1,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true),
          (_unref(isWaitStep))
            ? (_openBlock(), _createBlock(WaitStep, {
                key: 2,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true),
          (_unref(isEmailStep))
            ? (_openBlock(), _createBlock(EmailStep, {
                key: 3,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true),
          (_unref(isSubscribeStep))
            ? (_openBlock(), _createBlock(SubscribeStep, {
                key: 4,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true),
          (_unref(isConditionStep))
            ? (_openBlock(), _createBlock(ConditionStep, {
                key: 5,
                toggleDetails: props.toggleDetails,
                node: node.value
              }, null, 8, ["toggleDetails", "node"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})